module.exports = __webpack_public_path__ + "img/thumb_05.d38b426d.jpg";